var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BadgeAI',{attrs:{"offset-x":20,"offset-y":18,"visible":_vm.growthBook.ai_functionals && _vm.$can('use', 'aiRequirementsFromDocument')}},[_c('sButton',{attrs:{"color":"var(--white-color)","data-qa":"btn-compare","icon":"table","type":"text"},on:{"click":_vm.openCompareTable}},[_vm._v(" "+_vm._s(_vm.$t('Tenders.Compare'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }